// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3[data-v-b5a27ef0] {\n  margin: 24px 0 16px;\n}\n.series-checkboxes__item[data-v-b5a27ef0] {\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
